import type { Population } from "@models/ISchema";
import type { DataReducerType } from "../../../context/types";

export const buildPackageOnlyCreationData = (
  population: Population,
  termId: string,
  packageName: string,
): DataReducerType => ({
  link: null,
  populations: [population],
  assignments: {},
  deletions: {},
  creations: {
    [population.code]: {
      population,
      linkId: null,
      termId,
      packageName,
    },
  },
});
